<template>
	<v-form v-model="formValid" @submit.prevent="handleForm">
		<v-row>
			<v-col>
				<v-text-field
					v-model="cannedTextForm.canned_text_name"
					label="Name"
					name="canned_text_name"
					persistent-placeholder
					:error="hasErrors(cannedTextForm, 'canned_text_name')"
					:error-messages="errorMsg(cannedTextForm, 'canned_text_name')"
					outlined
					required
					dense />
				<v-textarea
					v-model="cannedTextForm.canned_text"
					label="Canned Text"
					name="canned_text"
					persistent-placeholder
					:error="hasErrors(cannedTextForm, 'canned_text')"
					:error-messages="errorMsg(cannedTextForm, 'canned_text')"
					outlined
					required
					dense />
				<v-btn type="submit"
					color="success"
					large
					rounded>
					Add Text
				</v-btn>
			</v-col>
		</v-row>
	</v-form>
</template>
<script>
import api from '@/api'

export default {
	props: {
		field: {
			type: String,
			required: true
		}
	},
	data () {
		return {
			formValid: true,
			cannedTextForm: this.$inertia.form({
				canned_text_name: null,
				canned_text: null
			})
		}
	},
	methods: {
		handleForm () {
			this.cannedTextForm.post(this.route('canned-text.store', this.field), {
				preserveScroll: true,
				preserveState: true,
				onSuccess: () => {
					this.cannedTextForm.reset()
					this.$emit('success')
				}
			})
		}
	}
}
</script>
